import { apiCall } from './gqlClient';

const GETINVOICETEMPLATE_QUERY = `
  query getInvoiceTemplate {
    getInvoiceTemplate
    {
      id
			providerId
			enabled
			docType
			logoFileId
			header
			footer
			numberPrefix
			numberNext
			legalName
			taxId
			billingAddressId
			language
			autoSend
			updatedAt
      ...fragments
    }
  }`;

export const getInvoiceTemplateApiCall = async (fragments = null) => apiCall({ query: GETINVOICETEMPLATE_QUERY, variables: {}, fragments });

const GETPROVIDERINVOICES_QUERY = `
  query getProviderInvoices($from: String, $to: String, $customerId: Int) {
    getProviderInvoices(from: $from, to: $to, customerId: $customerId)
    {
      id
			providerId
			orderId
			installmentId
			docType
			number
			issuedAt
			netCents
			taxCents
			grossCents
			currency
			pdfFileId
			status
			emailSentAt
			customerName
      ...fragments
    }
  }`;

export const getProviderInvoicesApiCall = async ({from, to, customerId}, fragments = null) => apiCall({ query: GETPROVIDERINVOICES_QUERY, variables: {from, to, customerId}, fragments });

const GETINVOICEBYORDER_QUERY = `
  query getInvoiceByOrder($orderId: Int!) {
    getInvoiceByOrder(orderId: $orderId)
    {
      id
			providerId
			orderId
			installmentId
			docType
			number
			issuedAt
			netCents
			taxCents
			grossCents
			currency
			pdfFileId
			status
			emailSentAt
			customerName
      ...fragments
    }
  }`;

export const getInvoiceByOrderApiCall = async ({orderId}, fragments = null) => apiCall({ query: GETINVOICEBYORDER_QUERY, variables: {orderId}, fragments });

const GETINVOICE_QUERY = `
  query getInvoice($id: Int!) {
    getInvoice(id: $id)
    {
      id
			providerId
			orderId
			installmentId
			docType
			number
			issuedAt
			netCents
			taxCents
			grossCents
			currency
			pdfFileId
			status
			emailSentAt
			createdAt
      ...fragments
    }
  }`;

export const getInvoiceApiCall = async ({id}, fragments = null) => apiCall({ query: GETINVOICE_QUERY, variables: {id}, fragments });

const GETMYINVOICES_QUERY = `
  query getMyInvoices {
    getMyInvoices
    {
      id
			providerId
			orderId
			number
			issuedAt
			netCents
			taxCents
			grossCents
			currency
			pdfFileId
			status
			providerName
      ...fragments
    }
  }`;

export const getMyInvoicesApiCall = async (fragments = null) => apiCall({ query: GETMYINVOICES_QUERY, variables: {}, fragments });

const GETINVOICEDOWNLOADURL_QUERY = `
  query getInvoiceDownloadUrl($id: Int!) {
    getInvoiceDownloadUrl(id: $id)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const getInvoiceDownloadUrlApiCall = async ({id}, fragments = null) => apiCall({ query: GETINVOICEDOWNLOADURL_QUERY, variables: {id}, fragments });

const UPSERTINVOICETEMPLATE_QUERY = `
  mutation upsertInvoiceTemplate($input: ProviderInvoiceTemplateInput!) {
    upsertInvoiceTemplate(input: $input)
    {
      id
			providerId
			enabled
			docType
			logoFileId
			header
			footer
			numberPrefix
			numberNext
			legalName
			taxId
			billingAddressId
			language
			autoSend
			updatedAt
      ...fragments
    }
  }`;

export const upsertInvoiceTemplateApiCall = async ({input}, fragments = null) => apiCall({ query: UPSERTINVOICETEMPLATE_QUERY, variables: {input}, fragments });

const GENERATEINVOICE_QUERY = `
  mutation generateInvoice($orderId: Int!) {
    generateInvoice(orderId: $orderId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const generateInvoiceApiCall = async ({orderId}, fragments = null) => apiCall({ query: GENERATEINVOICE_QUERY, variables: {orderId}, fragments });

const UPDATEINVOICE_QUERY = `
  mutation updateInvoice($invoiceId: Int!, $number: String, $linesJson: String) {
    updateInvoice(invoiceId: $invoiceId, number: $number, linesJson: $linesJson)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateInvoiceApiCall = async ({invoiceId, number, linesJson}, fragments = null) => apiCall({ query: UPDATEINVOICE_QUERY, variables: {invoiceId, number, linesJson}, fragments });

const RESENDINVOICE_QUERY = `
  mutation resendInvoice($invoiceId: Int!) {
    resendInvoice(invoiceId: $invoiceId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const resendInvoiceApiCall = async ({invoiceId}, fragments = null) => apiCall({ query: RESENDINVOICE_QUERY, variables: {invoiceId}, fragments });

const SENDTESTINVOICE_QUERY = `
  mutation sendTestInvoice {
    sendTestInvoice
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const sendTestInvoiceApiCall = async (fragments = null) => apiCall({ query: SENDTESTINVOICE_QUERY, variables: {}, fragments });
